import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { type Audit, getAuditsColumns } from "./columns";
import { type FilterAuditsSchema, FilterAudits } from "./filter";

const client = "admin-quantilia";
const table_name = "audits";

export const AuditsTable = () => {
  const { t, i18n } = useTranslation();
  const columns = useMemo(() => getAuditsColumns(t), [t, i18n.language]);

  return (
    <Table<Audit, FilterAuditsSchema>
      label={t("audits.title", {
        ns: "tables",
        defaultValue: "Modification history",
      })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterAudits />}
      disable_translations_request={true}
      actions={[]}
    />
  );
};
